export const rezlidhiaDefaultHeaders = [
    { label: 'NPI', key: 'npi_id' },
    { label: 'Name', key: 'name' },
    { label: 'Location', key: 'location' },
    { label: 'District', key: 'district' },
    { label: 'Specialty', key: 'specialty' },
    { label: 'Lead Segment', key: 'segmentation' },
    { label: 'Trigger Date', key: 'triggered_date' },
    { label: 'Trigger Type', key: 'triggered_type' },
    { label: 'Total Triggers', key: 'total_trigger' },
    {
        label: 'Total Touch Points',
        key: 'total_touch_points'
    },
    { label: 'Total Engagements', key: 'total_engagements' },
    { label: 'First Referral', key: 'first_referral' },
    { label: 'Last Rx Date', key: 'last_rx_date' },
    { label: 'Total Bottles', key: 'total_rx' },
    { label: 'Total Bottles Value', key: 'total_rx_value' },
    {
        label: 'Partner Preference',
        key: 'partner_preference'
    },
    {
        label: 'Channel Preference',
        key: 'channel_preference'
    }
];

export const csvHeaders = [
    { label: 'NPI', key: 'id' },
    { label: 'Name', key: 'name' },
    { label: 'Location', key: 'location' },
    {
        label: 'Channel Affinity',
        key: 'channel_preference'
    },
    {
        label: 'Partner Affinity',
        key: 'partner_preference'
    },
    { label: 'Physician Segment', key: 'segmentation' }
];

export const TABLE_HEADERS = [
    {
        key: 'npi_id',
        value: 'NPI'
    },
    {
        key: 'first_name',
        value: 'Name'
    },
    {
        key: 'address1',
        value: 'Location'
    },
    {
        key: 'channel_preference',
        value: 'Channel Affinity'
    },
    {
        key: 'partner_preference',
        value: 'Partner Affinity'
    },
    {
        key: 'segmentation',
        value: 'Physician Segment'
    }
];

export const handleEngagementCount = (arr, fieldEngagement) => {
    const successfulEngagement = [
        'click',
        'open',
        'clicked',
        'pageview',
        'video',
        'view'
    ];

    let engagementCount = arr.reduce((acc, curr) => {
        const isExists = successfulEngagement.includes(
            curr.action?.toLowerCase()
        );

        if (isExists) {
            return (acc += 1);
        }

        return acc;
    }, 0);
    if (!fieldEngagement.every(innerArr => innerArr.length === 0)) {
        engagementCount = engagementCount + 1;
    }
    return engagementCount;
};

export const getUniqueChannelsFromData = (exportProfilesData) => {
    const uniqueChannels = new Set();
    Object.values(exportProfilesData).forEach((providerData) => {
        const extendedEngagementData = providerData?.extended_engagement_data[0]?.field_engagement_data || [];                                      

        providerData.engagement_data.forEach((item) => {
            if (item.engagement_channel) {
                uniqueChannels.add(item.engagement_channel.toLowerCase());
            }
        });
        
        if (!extendedEngagementData?.every(innerArr => innerArr.length === 0)) {
            uniqueChannels.add('Sales Rep');
        }
    });

    return Array.from(uniqueChannels);
};

export const countEngagementsByChannel = (engagementData, channels,fieldEngagement) => {
    const counts = {};
    
    channels.forEach((channel) => {
        if (channel.toLowerCase() === 'sales rep' && !fieldEngagement.every(innerArr => innerArr.length === 0)) {
            counts[`${channel}_engagements`] = 1;
        } else {
            counts[`${channel}_engagements`] = 0;
        }
    });

    const successfulEngagements = [
        'click',
        'open',
        'clicked',
        'pageview',
        'video',
        'view'
    ];

    engagementData.forEach((item) => {
        const action = item.action?.toLowerCase();
        const channel = `${item.engagement_channel?.toLowerCase()}_engagements`;
        if (
            successfulEngagements.includes(action) &&
            counts.hasOwnProperty(channel) &&
            channel !== 'sales rep_engagements'
        ) {
            counts[channel] += 1;
        }
    });

    return counts;
};


export const countTouchPointsByChannel = (channels_touch_points,dynamicChannelHeaders,fieldEngagement) => {
    const channelTouchPoints = {};
    let fieldTouchPoint = 0;
    if (!fieldEngagement.every(innerArr => innerArr.length === 0)) {
        fieldTouchPoint = 1;
    }
    dynamicChannelHeaders.forEach((channel) => {
        const normalizedChannel = channel.toLowerCase();
        const normalizedTouchPoints = Object.keys(channels_touch_points)
            .reduce((acc, key) => {
                acc[key.toLowerCase()] = channels_touch_points[key];
                return acc;
            }, {});
        channelTouchPoints[`${channel}_touch_points`] = 
            normalizedChannel === 'sales rep' ? fieldTouchPoint : (normalizedTouchPoints[normalizedChannel] || 0);
    });
    return channelTouchPoints;
};

export const countTotalTouchPoints = (TouchPoints, fieldEngagement) =>{
    let touchPoint = TouchPoints;
    if (!fieldEngagement.every(innerArr => innerArr.length === 0)) {
        touchPoint = touchPoint + 1;
    }
    return touchPoint;
};